export const YELLOW = "rgb(235, 194, 0)";
export const YELLOW_WITH_OPACITY = "rgb(235, 194, 0, 0.1)";
